import styles from './Accordion.module.css';
import classNames from 'classnames';
import { AccordionItem } from './AccordionItem/AccordionItem';

export interface AccordionModifiers {
  variant: 'primary' | 'secondary';
  isItalic?: boolean;
  isLarge?: boolean;
}
interface AccordionProps extends AccordionModifiers {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}

export const Accordion = ({
  items,
  variant,
  isItalic,
  isLarge,
}: AccordionProps) => {
  const AccordionClasses = classNames(styles.Accordion, {
    [styles['Accordion--is-italic']]: isItalic,
    [styles['Accordion--is-large']]: isLarge,
  });

  return (
    <div className={AccordionClasses}>
      {items.map((item) => (
        <AccordionItem
          key={item.title}
          title={item.title}
          variant={variant}
          isItalic={isItalic}
          isLarge={isLarge}
        >
          {item.content}
        </AccordionItem>
      ))}
    </div>
  );
};
